import React, { useEffect, useState } from "react";
import LinkPagoGenerado from "../componentes/LinkPagoGenerado";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { getData } from "../../../../../services/library";

const DialogVerLink = ({open, onClose, dataPedido}) => {
  const [link, setLink] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [linkCopied, setLinkCopied] = useState(false);
  
  useEffect(() => {
  getData("/envasado_link_pago/xpedido/" + dataPedido.id, (data) => {
    if (data && data.length > 0) {
      // Transformar el primer elemento del array
      const transformedLink = {
        // id: data[0].id,
        id: data[0].id_pedido,
        url: data[0].link, // Cambiar 'link' por 'url'
        activo: data[0].activo,
        usuario: data[0].usuario,
        created_at: data[0].created_at,
        updated_at: data[0].updated_at
      };
      setLink(transformedLink);
    }
    setCargando(false);
  });
}, [dataPedido.id]);

  const copiarLink = () => {
    if (!link?.url) return;

    navigator.clipboard
      .writeText(link.url)
      .then(() => {
        setLinkCopied(true);
        setTimeout(() => setLinkCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Error copiando:", err);
      });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Ver link de pago
            </Typography>
          </DialogTitle>
        </Box>

        <DialogContent>
            {link?
            
          <LinkPagoGenerado
            paymentLink={link}
            //   pedido={dataPedido}
            //   totalGeneral={totalGeneral}
            linkCopied={linkCopied}
            onCopiarLink={copiarLink}
            //   onVolver={() => {
            //     setMostrarLinkGenerado(false);
            //     setMostrarResumen(true);
            //   }}
            //   renglones={renglones}
          />
            : cargando ? "cargando..." : "El pedido no tiene un link de pago activo."}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default DialogVerLink;
